import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

const TitleSplitter = ({ title }) => {

    useEffect(() => {
        AOS.init();
    }, [])

    const splitArrayWords = title.split(" ")


    return (
        <>
            {splitArrayWords?.map((word, i) => {

                const splitArrayChars = word.split("")

                return ( 
                    <div style={{display: "inline-block"}} key={i}>
                        {splitArrayChars.map((char, i) => {

                            return (
                                <div 
                                    data-aos={`flip-up-fade`}
                                    data-aos-delay={i * 50}
                                    data-aos-duration={100}
                                    style={{
                                        position: "relative",
                                        display: "inline-block"
                                    }}
                                    key={i}
                                    dangerouslySetInnerHTML={ 
                                        char === " " ? { __html: `&nbsp` } : {__html: char} 
                                    }
                                />
                            )
                        })}
                        <div style={{display: "inline-block"}} dangerouslySetInnerHTML={ { __html: `&nbsp` }  } />
                    </div>
                )
            })}

            
        </>
    )
}

export default TitleSplitter